import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import { LoaderEvent } from '../../shared/message.event';
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'terms-modal',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.css'],
    providers: [LoaderEvent],
    exportAs: 'termsPopUpObj'
})
export class TermsComponent implements OnInit {
    @ViewChild('childModal') childModal: ModalDirective;
    @Input() message = '';
    @Input() popupTitle;
    @Input() cancleButton;
    // @Output() notify: EventEmitter<string> = new EventEmitter<string>();
    @Output() notify = new EventEmitter<boolean>();
    @Output() notifyDelete = new EventEmitter<boolean>();
    @Input() deleteMessage;

    constructor(public router: Router, private loaderEvent: LoaderEvent) { }

    ngOnInit() {
    }

    public showChildModal(email): void {
        (email) ? localStorage.setItem('member_email', btoa(email)) : '';
        this.childModal.config.backdrop = false;
        this.childModal.show();
    }

    public hideChildModal(): void {
        this.childModal.hide();
    }

    onClickOk() {
        this.notify.emit(true);
    }

    onClickCancle() {
        this.notify.emit(false);
    }
}



// WEBPACK FOOTER //
// ./src/app/authentication/terms/terms.component.ts